import { ToolPageShell } from '@/shared/seo'
import { HtmlVPdfForm } from './HtmlVPdfForm'

export function HtmlVPdfPage() {
  return (
    <ToolPageShell utilityKey="htmlToPdf">
      <HtmlVPdfForm />
    </ToolPageShell>
  )
}
